
/**
 * Simple, accessible functionality for the Modal DDS component.
 */

const Cobalt = Cobalt || {};

(function($) {
  const instances = [];

  let $ariaHide;

  function init() {
    $ariaHide = $('body>header').add('body>footer').add('#content-primary');
    console.log($ariaHide);

    $('.modal').each(function(){
      instances.push(new Modal($(this)));
    });
  }

  const Modal = function($el) {
    this.$el = $el;

    // Move to outside main container so we can aria hide the rest of the page.
    this.$el.appendTo($('body'));
    this.$overlay = this.$el.find('.modal-overlay');

    // Create a dummy focusable element to help trap focus.
    this.$focusDummy = $('<div tabindex="0"> </div>')
      .appendTo(this.$el);

    this.$trigger = $('[data-modal-target="#' + this.$el.attr('id') + '"]');
    this.$close = this.$el.find('.modal-close');

    this.onTriggerClick = this.onTriggerClick.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);

    this.$trigger.on('click', this.onTriggerClick);
    this.$close.on('click', this.onCloseClick);
    this.$overlay.on('click', this.onCloseClick);

    this.onKeyUp = this.onKeyUp.bind(this);
    this.trapFocus = this.trapFocus.bind(this);
  };

  Modal.prototype.onTriggerClick = function(event) {
    event.preventDefault();
    this.open();
  };

  Modal.prototype.onCloseClick = function(event) {
    event.preventDefault();
    this.close();
    this.$el.attr('aria-hidden', true);
  };

  Modal.prototype.onKeyUp = function (event) {
    var key = event.which || event.keyCode;

    if (key === 27) { // ESC
      event.stopPropagation();
      this.close();
    }
  };

  Modal.prototype.trapFocus = function(event) {
    if (!$.contains(this.$el.get(0), event.target) || this.$focusDummy.is(event.target)) {
      this.$el.focus();
    }
  };

  Modal.prototype.open = function() {
    this.$el.addClass('is-active');
    this.$el.attr('aria-hidden', false);
    $ariaHide.attr('aria-hidden', true);
    this.$el.focus();
    $(document).on('keyup', this.onKeyUp);
    document.addEventListener('focus', this.trapFocus, true);
  };

  Modal.prototype.close = function() {
    $(document).off('keyup', this.onKeyUp);
    document.removeEventListener('focus', this.trapFocus, true);
    this.$el.removeClass('is-active');
    $ariaHide.attr('aria-hidden', false);
    this.$el.attr('aria-hidden', true);
    this.$trigger.focus();
  };

  $(document).ready(init);

  Cobalt.Modal = Modal;
})(jQuery);